export default __webpack_public_path__ + "static/media/alert_danger.7c7ba790.svg";